<template>
  <div>
    <el-row>
      <EditViewForm 
        :handle_dynamic_form_update="handle_dynamic_form_update"
        :handle_file_upload="()=>{}"
        :page_structure="page_structure"
        :preloaded_data="context"
        mode="edit"
        :preloaded_data_update_flag="preloaded_data_update_flag"
        />
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: right;vertical-align: middle;">
        <el-button icon="el-icon-back" @click="handle_cancel_deputy_button_click">取消審核代理</el-button>
        <el-button icon="el-icon-edit" @click="handle_save_button_click">確定</el-button>
      </el-col>
    </el-row>
    <LoadingBlock :active="loading"></LoadingBlock>
  </div>
</template>

<script>
import api from '@/api/index'
import axios from 'axios'
import _ from 'lodash'
import LoadingBlock from '@/components/backstage/LoadingBlock/LoadingBlock.vue'
import PageStructure from '@/views/backstage/structure/review_management/AssignReviewDeputyPageStructure'
import EditViewForm from '@/components/backstage/EditViewForm/EditViewForm.vue'

  export default {
    components: {
      LoadingBlock,
      EditViewForm,
    },
    data() {
      return {
        loading: false,//TODO: change this to true
        page_structure: [],
        context: {}, 
        resource_api: process.env.VUE_APP_API_BACKSTAGE_URL + '/account',
        resource_identifier: 'id',
        account_id: null,
        preloaded_data_update_flag: 0
      }
    },
    computed: {
      mode () {
        return this.account_id? 'edit': 'add'
      }
    },
    created: async function () {
        console.log('AssignReviewDeputyPage: route id:', this.$route.params.id)

        this.page_structure = PageStructure(this.$route.params.type)
        console.log('AssignReviewDeputyPage: page structure:', this.page_structure)

        this.account_id = this.account_info['id']
        console.log('AssignReviewDeputyPage: account id:', this.account_id)

        //TODO: check deputy permission

        this.init_context()  
        await this.get_context()
        this.preloaded_data_update_flag += 1
    },
    methods: {
      init_context (){
        let temp = this.forge_context_container(this.page_structure)

        this.context = JSON.parse(JSON.stringify(temp))
        console.log('AssignReviewDeputyPage: context: ', this.context)
      },
      async handle_save_button_click () {
        console.log('save button clicked')

        this.loading = true
        let res = await api.assign_deputy(this.context['fk_agent_user_id'])
        if (!res.success) {
          console.log('AssignReviewDeputyPage: save/edit failed, err=', res.error)
          this.notify_message(this.ERROR.LEVEL.ERROR, '新增/編輯失敗', this.ERROR.MSG.general_err_msg)
        }
        else {
          this.notify_message(this.ERROR.LEVEL.SUCCESS, '已指定審核代理')
        }
        this.loading = false

        this.init_context()  
        await this.get_context()
        this.preloaded_data_update_flag += 1
      },
      async handle_cancel_deputy_button_click () {
        this.loading = true
        let res = await api.cancel_deputy()
        if (!res.success) {
          console.log('AssignReviewDeputyPage: cancel failed, err=', res.error)
          this.notify_message(this.ERROR.LEVEL.ERROR, '取消失敗', this.ERROR.MSG.general_err_msg)
        }
        else {
          this.notify_message(this.ERROR.LEVEL.SUCCESS, '已取消審核代理')
        }
        this.loading = false
        
        this.init_context()  
        await this.get_context()
        this.preloaded_data_update_flag += 1

        this.$emit('done')
      },
      async get_context () {
        if (!this.account_id) {
          return
        }

        let self = this

        this.loading = true
  
        await axios.get(this.resource_api+'/get', {params: {
            id: this.account_id
        }})
            .then(async (response) => {
              console.log('reponse: ', response.data.payload)

              if (response.data.success) {
                  //debugger
                  if (response.data.payload['fk_agent_user_id']) {
                    let res = await api.get_account(response.data.payload['fk_agent_user_id'])
                    //debugger
                    if (res.success === true) {
                      response.data.payload['deputy_org_name'] = res.payload['org_name']
                      response.data.payload['deputy_user_name'] = res.payload['username']
                    }
                    else {
                      response.data.payload['deputy_org_name'] = null
                      response.data.payload['deputy_user_name'] = null
                    }
                  }

                  let res = self.translate_to_edit_data(this.page_structure, response.data.payload, {mode: 'edit'})
                  for (let key in res) {
                      self.context[key] = res[key]
                  }
              }
              else {
                this.notify_message(this.ERROR.LEVEL.ERROR, '無法取得資料', response.data.message)
              }
            })
            .catch(err => {
                console.log(err)
                this.notify_message(this.ERROR.LEVEL.ERROR, '無法取得資料', this.ERROR.MSG.general_err_msg)
            })

        this.loading = false
      },
      handle_dynamic_form_update (key, form_value) {
        console.log('AssignReviewDeputyPage: handle_dynamic_form_update:' + key + ', value:', form_value)

        this.$set(this.context, key, form_value)
      }
    }
  };
</script>

<style>
</style>
